import axios from "axios";

const getUserIP = async () => {
    const isDemo = String(process.env.REACT_APP_DEMO).toLowerCase() === 'true';
    if (isDemo) {
        return "127.0.0.1";
    }
    try {
        const res = await axios.get("https://api.ipify.org/?format=json");    
        return res.data.ip;
    } catch (err) {
        console.warn("Unable to reach ipify service, using default IP 127.0.0.1");
        return "127.0.0.1";
    }
}; 

export default getUserIP;